var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          attrs: { "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission:SettingUserAccountStrategy",
                          arg: "SettingUserAccountStrategy",
                        },
                      ],
                      on: { click: _vm.reFresh },
                    },
                    [_vm._v(_vm._s(_vm.$t("resetText")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission:SettingUserAccountStrategy",
                          arg: "SettingUserAccountStrategy",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("AccountSecurityPolicy.top.security"))),
          ]),
        ]
      ),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: {
            "label-position": "top",
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "200px",
            inline: "",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.top.Default"),
                        prop: "originalPassword",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.originalPassword,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "originalPassword", $$v)
                          },
                          expression: "form.originalPassword",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.top.Minlength"),
                        prop: "minLength",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.minLength,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "minLength", $$v)
                          },
                          expression: "form.minLength",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.top.Maxlength"),
                        prop: "maxLength",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.maxLength,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "maxLength", $$v)
                          },
                          expression: "form.maxLength",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.top.lowercase"),
                        prop: "lowercaseCount",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.lowercaseCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "lowercaseCount", $$v)
                          },
                          expression: "form.lowercaseCount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.top.uppercase"),
                        prop: "uppercaseCount",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.uppercaseCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "uppercaseCount", $$v)
                          },
                          expression: "form.uppercaseCount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.top.special"),
                        prop: "specialCharCount",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.specialCharCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "specialCharCount", $$v)
                          },
                          expression: "form.specialCharCount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.top.oldpassword"),
                        prop: "isPassword",
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.isPassword,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isPassword", $$v)
                          },
                          expression: "form.isPassword",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.top.loginname"),
                        prop: "notUsername",
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.notUsername,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "notUsername", $$v)
                          },
                          expression: "form.notUsername",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("AccountSecurityPolicy.bottom.security"))),
          ]),
          _c(
            "el-row",
            { staticClass: "border" },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.bottom.Maxerrors"),
                        prop: "maxErrorTime",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.maxErrorTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "maxErrorTime", $$v)
                          },
                          expression: "form.maxErrorTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.bottom.Maxrecent"),
                        prop: "notRecentCount",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.notRecentCount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "notRecentCount", $$v)
                          },
                          expression: "form.notRecentCount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountSecurityPolicy.bottom.errorscode"
                        ),
                        prop: "maxCheckCaptcha",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.maxCheckCaptcha,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "maxCheckCaptcha", $$v)
                          },
                          expression: "form.maxCheckCaptcha",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "AccountSecurityPolicy.bottom.verification"
                        ),
                        prop: "enableCaptcha",
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.enableCaptcha,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "enableCaptcha", $$v)
                          },
                          expression: "form.enableCaptcha",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.bottom.locked"),
                        prop: "enableLock",
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.enableLock,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "enableLock", $$v)
                          },
                          expression: "form.enableLock",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.bottom.duration"),
                        prop: "lockedExpireTime",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.lockedExpireTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "lockedExpireTime", $$v)
                          },
                          expression: "form.lockedExpireTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.bottom.PC"),
                        prop: "enableWebMultipleLogin",
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.enableWebMultipleLogin,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "enableWebMultipleLogin", $$v)
                          },
                          expression: "form.enableWebMultipleLogin",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.bottom.Mobile"),
                        prop: "enableAppMultipleLogin",
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.enableAppMultipleLogin,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "enableAppMultipleLogin", $$v)
                          },
                          expression: "form.enableAppMultipleLogin",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.bottom.initial"),
                        prop: "forceModifyPassword",
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.forceModifyPassword,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "forceModifyPassword", $$v)
                          },
                          expression: "form.forceModifyPassword",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.bottom.after"),
                        prop: "enableReLogin",
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.enableReLogin,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "enableReLogin", $$v)
                          },
                          expression: "form.enableReLogin",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("AccountSecurityPolicy.bottom.secondary"),
                        prop: "enableSecurity",
                      },
                    },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.form.enableSecurity,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "enableSecurity", $$v)
                          },
                          expression: "form.enableSecurity",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }